// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateRangeLabelComponent } from './components/date-range-label/date-range-label.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [DateRangeLabelComponent],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [
    DateRangeLabelComponent,
  ],
})
export class DateRangeLabelModule {
}
